var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},_vm._l((this.initialListe),function(nc){return _c('CarteNonConformite',{key:nc.id,attrs:{"initialNc":nc}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }